export const MINI_RELEASED_DUTIES_BUTTON_1 = 'mini1';
export const MINI_RELEASED_DUTIES_BUTTON_2 = 'mini2';
